<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

const { currentAccount } = useAccount();
const logoUrl = computed(() => currentAccount.value?.branding?.logo_url);
const darkLogoUrl = computed(
  () => currentAccount.value?.branding?.logo_dark_url || logoUrl.value
);
const displayName = computed(
  () =>
    currentAccount.value?.branding?.display_name ||
    currentAccount.value?.name ||
    ''
);
const initials = computed(() =>
  displayName.value
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase()
);
</script>

<template>
  <div class="grid place-content-center overflow-hidden">
    <template v-if="logoUrl">
      <img
        :src="logoUrl"
        :alt="displayName"
        class="block dark:hidden size-full object-contain"
      />
      <img
        :src="darkLogoUrl"
        :alt="displayName"
        class="hidden dark:block size-full object-contain"
      />
    </template>
    <span
      v-else
      class="grid size-full place-content-center rounded-md bg-n-brand/10 text-[0.625rem] font-semibold text-n-brand"
      aria-hidden="true"
    >
      {{ initials }}
    </span>
  </div>
</template>
